<template>
    <div>
        <move-selected-addresses-to-delivery-project
            v-if="selectedAddresses.length"
            :project="deliveryProject"
            :projects="deliveryProjects"
            :selected-addresses="selectedAddresses"
        />
        <div class="card">
            <div class="flex justify-between items-center">
                <h4 class="card__title">Adresser</h4>
                <toggle-table-columns store-name="deliveryProjectAddressesTable" />
            </div>
            <div class="overflow-x-auto">
                <table class="table">
                    <thead>
                        <tr>
                            <th width="60">
                                <checkbox-input
                                    v-model="allAddressesSelected"
                                    class="mr-md"
                                    @toggle="toggleAllSelected"
                                />
                            </th>
                            <th class="min-w-lg">
                                Adress
                                <slot name="sorting" />
                            </th>
                            <th
                                v-for="column in selectedColumns"
                                :key="`delivery-project-addresses-thead-${column.value}`"
                                class="min-w-lg"
                            >
                                {{ column.label }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <delivery-project-address-item
                            v-for="address in addresses.data"
                            :key="address.id"
                            :delivery-project="deliveryProject"
                            :initial-address="address"
                            @toggleAddressSelected="toggle"
                        />
                        <tr v-if="! addresses.data.length">
                            <td colspan="5" class="empty-state">
                                Det finns inga adresser
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import DeliveryProjectAddressItem from './AddressListItem';

    export default {
        components: { DeliveryProjectAddressItem },
        props: {
            addresses: {
                required: true,
                type: Object, // paginator object
            },
            deliveryProject: {
                required: true,
                type: Object,
            },
            deliveryProjects: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                selectedAddresses: [],
                allAddressesSelected: false,
            };
        },
        computed: mapGetters({
            selectedColumns: 'deliveryProjectAddressesTable/selectedColumns',
        }),
        methods: {
            toggleAllSelected() {
                this.selectedAddresses = [];
                EventBus.$emit('all-addresses-toggled', this.allAddressesSelected);
            },
            toggle(address, selected) {
                if (selected) {
                    this.selectedAddresses.push(address);
                } else {
                    const index = this.selectedAddresses.findIndex(a => a.id === address.id);
                    this.selectedAddresses.splice(index, 1);
                }
            },
        },
    };
</script>
